import { css } from 'linaria';

export namespace Styles {
  export const onelineLayout = css`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: var(--space-200);
  `;
}
